import React from 'react';
import { Box, Container, Grid, Typography, Paper, Chip, Button } from '@mui/material';
import { ArrowForward as ArrowIcon, School as SchoolIcon } from '@mui/icons-material';
import { Reveal, HOME_COLORS, sectionLabelSx } from './common';

export const PROGRAMS = [
  { code: 'B.Sc N', name: 'B.Sc Nursing', duration: '4 Years', eligibility: '10+2 with PCB, min. 45%', desc: 'A comprehensive undergraduate degree covering fundamentals, medical-surgical, community and psychiatric nursing.' },
  { code: 'GNM', name: 'General Nursing & Midwifery', duration: '3.5 Years', eligibility: '10+2 any stream, min. 40%', desc: 'A diploma program focused on general nursing care and midwifery practice, widely recognized across hospitals.' },
  { code: 'P.B.Sc N', name: 'Post Basic B.Sc Nursing', duration: '2 Years', eligibility: 'GNM with registration', desc: 'Designed for registered nurses to upgrade to a full B.Sc Nursing degree with advanced clinical specialization.' },
  { code: 'M.Sc N', name: 'M.Sc Nursing', duration: '2 Years', eligibility: 'B.Sc Nursing with registration', desc: 'A postgraduate program building specialization and leadership skills across nursing sub-disciplines.' },
];

const ICON_GRADIENTS = [
  [HOME_COLORS.dark, HOME_COLORS.teal],
  [HOME_COLORS.sky, HOME_COLORS.skyLight],
  [HOME_COLORS.mid, HOME_COLORS.sky],
  [HOME_COLORS.dark, HOME_COLORS.sky],
];

export default function ProgramsSection({ onApply }) {
  return (
    <Box id="programs" sx={{ py: { xs: 8, md: 12 }, bgcolor: HOME_COLORS.paper, scrollMarginTop: '80px' }}>
      <Container maxWidth="lg">
        <Reveal>
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography sx={sectionLabelSx}>Programs Offered</Typography>
            <Typography variant="h3" sx={{ fontWeight: 800, color: HOME_COLORS.dark, fontSize: { xs: '2rem', md: '2.6rem' } }}>
              Choose your path in nursing
            </Typography>
            <Typography sx={{ color: '#657875', maxWidth: 640, mx: 'auto', mt: 1.5 }}>
              Recognized diploma and degree programs designed to take you from foundational care to advanced clinical specialization.
            </Typography>
          </Box>
        </Reveal>

        <Grid container spacing={3}>
          {PROGRAMS.map((p, idx) => {
            const [c1, c2] = ICON_GRADIENTS[idx % ICON_GRADIENTS.length];
            return (
              <Grid item xs={12} sm={6} md={3} key={p.code}>
                <Reveal delay={idx * 90} sx={{ height: '100%' }}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 3.5, borderRadius: 4, height: '100%', display: 'flex', flexDirection: 'column',
                      border: '1px solid #dcebe7', bgcolor: '#fff', position: 'relative', overflow: 'hidden',
                      transition: 'transform 0.35s ease, box-shadow 0.35s ease',
                      '&:hover': { transform: 'translateY(-8px)', boxShadow: '0 20px 40px rgba(0,77,64,0.15)' },
                      '&:hover .program-icon': { transform: 'scale(1.1) rotate(6deg)' },
                    }}
                  >
                    <Box className="program-icon" sx={{
                      width: 54, height: 54, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                      background: `linear-gradient(135deg, ${c1}, ${c2})`, mb: 2, transition: 'transform 0.35s ease',
                    }}>
                      <SchoolIcon sx={{ color: '#fff' }} />
                    </Box>
                    <Chip size="small" label={p.duration} sx={{ alignSelf: 'flex-start', mb: 1.5, bgcolor: 'rgba(14,165,233,0.1)', color: HOME_COLORS.dark, fontWeight: 700 }} />
                    <Typography sx={{ fontWeight: 800, color: HOME_COLORS.dark, fontSize: '1.1rem', mb: 1 }}>{p.name}</Typography>
                    <Typography variant="body2" sx={{ color: '#657875', mb: 2, flex: 1 }}>{p.desc}</Typography>
                    <Typography variant="caption" sx={{ color: '#8a9a97', mb: 2, display: 'block' }}>
                      <strong>Eligibility:</strong> {p.eligibility}
                    </Typography>
                    <Button
                      onClick={() => onApply(p.name)}
                      endIcon={<ArrowIcon />}
                      sx={{ alignSelf: 'flex-start', fontWeight: 700, color: HOME_COLORS.mid, px: 0, '&:hover': { bgcolor: 'transparent', color: HOME_COLORS.dark } }}
                    >
                      Apply now
                    </Button>
                  </Paper>
                </Reveal>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
}
